import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { encryptWithPublicKey, generateUserSign } from './P2PHelper';
import { handleNewP2Pkeys } from './createP2PKeys';
import { getUUID } from './getUuid';
import { sendP2PSocketData } from './p2pConnection';

export const responseCredentials = async (dataRec: { my_key: string }) => {
    const uuids = await getUUID();

    const { sign } = await generateUserSign({
        uuid: uuids[0].uuid,
        userId: uuids[0].user_id,
    });
    const { publicKeyStringified } = await handleNewP2Pkeys(uuids[0].keypair);

    const encryptedUserHash = await encryptWithPublicKey(sign, dataRec.my_key);
    const encryptedUserId = await encryptWithPublicKey(
        uuids[0].user_id,
        dataRec.my_key,
    );
    const encryptedUUid = await encryptWithPublicKey(
        uuids[0].uuid,
        dataRec.my_key,
    );
    const isInUploadKeyPage = store.getState().p2pReducer.isInUploadKeyPage;
    const activeServer = store.getState().serverDataReducer.activeServer;
    const serverDetails =
        store.getState().serverDataReducer.serverData?.[activeServer];
    const privateKey = serverDetails?.privateKey ?? '';
    if (isInUploadKeyPage && (!privateKey || privateKey === '')) {
        store.dispatch(
            p2pActions.updatePeerFound('Requesting validation from your peer'),
        );

        sendP2PSocketData({
            command: 'send_msg',
            data: {
                client_event: 'validate_me',
                user_id: encryptedUserId,
                uuid: encryptedUUid,
                sign: encryptedUserHash,
                encrypted_key: publicKeyStringified,
            },
        });
    }
};
